import {HelmetProvider} from 'react-helmet-async';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import CanonicalTag from './components/CanonicalTag';
import ScrollToTop from './components/ScrollToTop';
import {Root} from './pages';
import GlobalProvider from './providers/primereact';
import {persistor, store} from './redux';

const App = () => {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <GlobalProvider>
            <BrowserRouter>
              <CanonicalTag />
              <ScrollToTop>
                <Root />
              </ScrollToTop>
            </BrowserRouter>
          </GlobalProvider>
        </PersistGate>
      </Provider>{' '}
    </HelmetProvider>
  );
};

export default App;
